import { useState } from 'react';
import { config } from '@/lib/config';

const API_OVERRIDE_KEY = '_tgd_api_override';

export function PreviewBanner() {
    const [isEditing, setIsEditing] = useState(false);
    const [inputValue, setInputValue] = useState('');

    const currentOverride = sessionStorage.getItem(API_OVERRIDE_KEY);
    const isUsingOverride = Boolean(currentOverride);

    const handleSet = () => {
        if (!inputValue.trim()) return;
        const url = inputValue.trim().replace(/\/+$/, '');
        sessionStorage.setItem(API_OVERRIDE_KEY, url);
        window.location.reload();
    };

    const handleClear = () => {
        sessionStorage.removeItem(API_OVERRIDE_KEY);
        window.location.reload();
    };

    return (
        <div className="flex items-center gap-2 border-b border-amber-200 bg-amber-50 px-4 py-1.5 text-xs text-amber-800 dark:border-amber-800 dark:bg-amber-950/40 dark:text-amber-300">
            <span className="font-semibold">Preview</span>
            <span className="text-amber-600 dark:text-amber-400">→</span>
            <span className="font-mono text-[11px]">{config.apiBaseUrl}</span>

            {isEditing ? (
                <form
                    onSubmit={(e) => { e.preventDefault(); handleSet(); }}
                    className="ml-auto flex items-center gap-1.5"
                >
                    <input
                        autoFocus
                        type="text"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        placeholder="https://tagadapay-git-xxx.vercel.app"
                        className="w-72 rounded border border-amber-300 bg-white px-2 py-0.5 text-[11px] font-mono text-amber-900 outline-none focus:ring-1 focus:ring-amber-400 dark:border-amber-700 dark:bg-amber-950 dark:text-amber-200"
                    />
                    <button
                        type="submit"
                        className="rounded bg-amber-600 px-2 py-0.5 text-[11px] font-medium text-white hover:bg-amber-700"
                    >
                        Set
                    </button>
                    <button
                        type="button"
                        onClick={() => setIsEditing(false)}
                        className="text-[11px] text-amber-500 hover:text-amber-700"
                    >
                        Cancel
                    </button>
                </form>
            ) : (
                <div className="ml-auto flex items-center gap-2">
                    <button
                        onClick={() => { setInputValue(currentOverride || ''); setIsEditing(true); }}
                        className="rounded border border-amber-300 px-2 py-0.5 text-[11px] font-medium hover:bg-amber-100 dark:border-amber-700 dark:hover:bg-amber-900"
                    >
                        Change API
                    </button>
                    {isUsingOverride && (
                        <button
                            onClick={handleClear}
                            className="text-[11px] text-amber-500 underline hover:text-amber-700"
                        >
                            Reset
                        </button>
                    )}
                </div>
            )}
        </div>
    );
}
